export const ApiSettingsNumberRanges = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (id, payload) => {
    const result = await axios.post(`/api/settings/number-ranges/${id}`, payload)
    return result.data
  }

  const find = async (id) => {
    let result
    if (id) {
      result = await axios.get(`/api/settings/number-ranges/${id}`)
    } else {
      result = await axios.get('/api/settings/number-ranges/0')
    }
    return result.data
  }

  const load = async () => {
    const result = await axios.get('/api/settings/number-ranges')
    return result.data
  }

  return {
    numberRangesFind: find,
    numberRangesLoad: load,
    numberRangesSave: save
  }
}
